import { Attribute, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { SpinnerService } from '../../../services/spinner.service';
import { DownloadService } from '../../../services/download.service';
import { SnackbarService } from '../../../services/snackbar.service';
import {
  GestoresResiduosEstadosControllerService,
  GestoresResiduosControllerService,
  ProvinciaControllerService,
  GestionResiduosFilterDTO,
  PageDTOGestoresResiduosDTO,
  DiccionarioControllerService,
  DiccionarioElementoDTO,
} from 'api-rest';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { HoldersService } from '../../../services/holders.service';
import { forkJoin } from 'rxjs';
import { WasteManagersStatusChangeDialogComponent } from '../waste-managers-status-change-dialog/waste-managers-status-change-dialog.component';
import { WasteManagersBajaMotivoDialogComponent } from '../waste-managers-baja-motivo-dialog/waste-managers-baja-motivo-dialog.component';

@Component({
  selector: 'lib-waste-managers-search',
  templateUrl: './waste-managers-search.component.html',
  styleUrls: ['./waste-managers-search.component.scss'],
})
export class WasteManagersSearchComponent implements OnInit {
  pageNumber: number = 0;
  pageSize: number = 25;
  recordsTotal: number = 0;

  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;
  flagSearch: boolean = false;
  totalElements: number = 0;
  totalSearch: number = 0;

  provinciaArray: any[] = [];
  estadoArray: any[] = [];

  headArray: any = [
    {
      Head: 'ID. Gestor/Acondicionador',
      FieldName: 'id',
    },
    {
      Head: 'Razón Social',
      FieldName: 'razonSocial',
    },
    {
      Head: 'Provincia',
      FieldName: 'provinciaFisica',
      Attribute: 'nombre',
    },
    {
      Head: 'Documento (NIE,NIF)',
      FieldName: 'codigoDocumento',
    },
    {
      Head: 'Estado',
      FieldName: 'gestoresResiduosEstado',
      Attribute: 'descripcion',
    },
    {
      Head: 'NIMA',
      FieldName: 'nima',
    },
    {
      Head: 'Acuerdo con Envalora',
      FieldName: 'acuerdoEnvalora',
      renderValue: (item: any) => (item?.acuerdoEnvalora == true ? 'Si' : 'No'),
    },
    {
      Head: 'Núm. Inscripción en registro (1)',
      FieldName: 'numInscripcion1',
    },
    {
      Head: 'Convenio Acondicionador',
      FieldName: 'convenioEnvalora',
      renderValue: (item: any) => (item?.convenioEnvalora == null ? '' : (item?.convenioEnvalora == true ? 'Si' : 'No')),
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        {
          nameButton: 'view',
          icon: 'open_in_new',
          toolTip: 'Editar',
          show: { params: 'canAccessView', accion: 'view' },
        },
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Borrar',
          show: { params: 'canAccessDelete', accion: 'delete' },
        },
        {
          nameButton: 'menu',
          array: [
            {
              nameButton: 'baja_gestor',
              name: 'Baja de Gestor',
              show: {
                params: 'canAccessDownManager',
                accion: 'baja_gestor',
              },
            },
          ],
        },
      ],
      width: '8',
      permanent: true,
    },
  ];
  gridArray: any[] = [];

  searchForm: FormGroup;
  optionArray = [{ value: 'Si' }, { value: 'No' }];
  mostrarFiltros: boolean = true;
  orden: DiccionarioElementoDTO[] = [];
  constructor(
    @Inject('environment') private environment: any,
    private formBuilder: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    public spinnerSrv: SpinnerService,
    private downloadService: DownloadService,
    private snackBarSrv: SnackbarService,
    private provinciaControllerService: ProvinciaControllerService,
    private gestoresResiduosEstadosControllerService: GestoresResiduosEstadosControllerService,
    private gestoresResiduosControllerService: GestoresResiduosControllerService,
    @Inject('EmpusaAuthenticationService')
    private authService: EmpusaAuthenticationService,
    private holdersService: HoldersService,
    private diccionarioControllerService: DiccionarioControllerService
  ) {
    this.searchForm = this.formBuilder.group({
      idGestor: [{ value: null, disabled: false }, [Validators.pattern('^[0-9;]+$')]],
      codigo_documento: [{ value: null, disabled: false }],
      razon_social: [{ value: null, disabled: false }],
      provincia_fisica: [{ value: null, disabled: false }],
      estado: [{ value: null, disabled: false }],
      nima: [{ value: null, disabled: false }],
      auto_peligrosidad: [{ value: null, disabled: false }],
      gestores: [{ value: null, disabled: false }],
      acondicionadores: [{ value: null, disabled: false }],
      acuerdoEnv: [{ value: null, disabled: false }],
      convAcondicionador: [{ value: null, disabled: false }],
                  orden: [{ value: null, disabled: false }],
      tipoOrden: [{ value: null, disabled: false }],
    });

    if (this.canAccessChangeStatus()) {
      this.headArray.filter((item: any) => item.FieldName == 'actions')[0].check = true;
    }
  }

  ngOnInit() {
    console.log('[WasteManagersSearch ngOnInit] Iniciando carga de datos');
    
    // Cargamos ambos combos y esperamos a que terminen
    forkJoin({
      estados: this.gestoresResiduosEstadosControllerService.findAll9(),
      provincias: this.provinciaControllerService.listarComunidades1({}, { page: 0, size: 500, sort: [] })
    }).subscribe({
      next: (res: any) => {
        this.estadoArray = res.estados;
        this.provinciaArray = res.provincias.datos;
        console.log('[WasteManagersSearch ngOnInit] Combos cargados con éxito');

        // Una vez cargados los combos, comprobamos si hay búsqueda guardada
        const storedForm = sessionStorage.getItem('wasteManagersSearchForm');
        if (storedForm) {
          try {
            const formData = JSON.parse(storedForm);
            console.log('[WasteManagersSearch ngOnInit] Restaurando formulario:', formData);
            
            this.searchForm.patchValue(formData);
            
            // Forzamos la búsqueda si había criterios
            this.searchData();
            
            // Limpiamos la sesión una vez restaurado
            sessionStorage.removeItem('wasteManagersSearchForm');
          } catch (e) {
            console.error('[WasteManagersSearch ngOnInit] Error al restaurar formulario:', e);
          }
        }
      },
      error: (err) => {
        console.error('[WasteManagersSearch ngOnInit] Error cargando combos:', err);
      }
    });
    this.getComboEstados();
    this.getComboProvincia();
    this.getComboOrden();
  }

  checked(event: any) {}

  renderPage(event: number) {
    this.pageNumber = event;
    if (this.flagSearch) {
      this.searchData();
    }
  }

  exportarExcel() {
    const { backendFilter, page, size } = this.getBackendFilter();
    this.gestoresResiduosControllerService
      .exportCSV3(backendFilter, 'response')
      .subscribe((res) => {
        this.downloadService.exportModal();
        // const filename = this.downloadService.getFileName(
        //   res.headers,
        //   'Exportacion_Gestor.csv'
        // );
        // this.downloadService.downloadCSV(res.body!, filename!);
      });
  }

  clearSearcher() {
    this.searchForm.reset();
    this.flagSearch = false;
    this.gridArray = [];
    // Limpiar sessionStorage cuando se limpia el formulario
    sessionStorage.removeItem('wasteManagersSearchForm');
    console.log('[WasteManagersSearch clearSearcher] sessionStorage limpiado');
  }

  compareProvincia = (p1: any, p2: any): boolean => {
    if (!p1 || !p2) return p1 === p2;
    return p1.id === p2.id;
  }

  compareEstado = (e1: any, e2: any): boolean => {
    if (!e1 || !e2) return e1 === e2;
    return e1.id === e2.id;
  }

  toggleFiltros(): void {
    this.mostrarFiltros = !this.mostrarFiltros;
  }

  quitarFiltro(filtro: { label: string; campo: string; value?: any }): void {
    if (filtro.value !== undefined) {
      const current = this.searchForm.get(filtro.campo)?.value as any[];
      if (Array.isArray(current)) {
        const updated = current.filter((v) =>
          v?.id !== undefined && filtro.value?.id !== undefined ? v.id !== filtro.value.id : v !== filtro.value
        );
        this.searchForm.get(filtro.campo)?.setValue(updated.length ? updated : null);
      }
    } else {
      this.searchForm.get(filtro.campo)?.reset();
    }
    //this.searchData(true);
  }

  get filtrosAplicados(): { label: string; campo: string; value?: any }[] {
    const filtros: { label: string; campo: string; value?: any }[] = [];

    const id = this.searchForm.get('idGestor')?.value;
    if (id) filtros.push({ label: ` ${id}`, campo: 'idGestor' });

    const doc = this.searchForm.get('codigo_documento')?.value;
    if (doc?.trim()) filtros.push({ label: doc.trim(), campo: 'codigo_documento' });

    const razon = this.searchForm.get('razon_social')?.value;
    if (razon?.trim()) filtros.push({ label: razon.trim(), campo: 'razon_social' });

    const nima = this.searchForm.get('nima')?.value;
    if (nima) filtros.push({ label: ` ${nima}`, campo: 'nima' });

    const provincia = this.searchForm.get('provincia_fisica')?.value;
    if (provincia) filtros.push({ label: provincia.nombre, campo: 'provincia_fisica' });

    const estados = this.searchForm.get('estado')?.value as any[];
    if (estados?.length) {
      estados.forEach((est: any) => {
        filtros.push({ label: est.descripcion ?? String(est), campo: 'estado', value: est });
      });
    }

    const acuerdoEnv = this.searchForm.get('acuerdoEnv')?.value;
    if (acuerdoEnv) filtros.push({ label: ` ${acuerdoEnv}`, campo: 'acuerdoEnv' });

    const convAcond = this.searchForm.get('convAcondicionador')?.value;
    if (convAcond) filtros.push({ label: ` ${convAcond}`, campo: 'convAcondicionador' });

    if (this.searchForm.get('auto_peligrosidad')?.value) {
      filtros.push({ label: 'Peligrosos', campo: 'auto_peligrosidad' });
    }
    if (this.searchForm.get('gestores')?.value) {
      filtros.push({ label: 'Gestores', campo: 'gestores' });
    }
    if (this.searchForm.get('acondicionadores')?.value) {
      filtros.push({ label: 'Acondicionadores', campo: 'acondicionadores' });
    }
const ordenes = this.searchForm.get('orden')?.value;
    if (Array.isArray(ordenes) && ordenes.length) {
      ordenes.forEach((ordenCodigo: any) => {
        filtros.push({
          label: `Orden: ${String(ordenCodigo)}`,
          campo: 'orden',
          value: ordenCodigo,
        });
      });
    } else if (ordenes) {
      filtros.push({ label: `Órdenes: ${String(ordenes)}`, campo: 'orden' });
    }

    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    if (tipoOrden) {
      const label =
        tipoOrden === 'ASC'
          ? 'Ascendente'
          : tipoOrden === 'DESC'
          ? 'Descendente'
          : String(tipoOrden);
      filtros.push({ label: `Tipo orden: ${label}`, campo: 'tipoOrden' });
    }
    return filtros;
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.searchForm.controls[controlName].hasError(errorName) &&
      this.searchForm.controls[controlName].touched
    );
  }

  private getBackendFilter() {
    const selectEstado = this.searchForm.get('estado')?.value;
    let selectEstadosId: any[] = [];
    if (selectEstado !== undefined && selectEstado !== null) {
      selectEstadosId = selectEstado.map((objeto: any) =>
        objeto.id !== undefined ? objeto.id : objeto
      );
    }
    let backendFilter: any = {
      id: this.searchForm.get('idGestor')?.value,
      codigoDocumento: this.searchForm.get('codigo_documento')?.value,
      razonSocial: this.searchForm.get('razon_social')?.value ? this.searchForm.get('razon_social')?.value.trim() : undefined,
      gestoresResiduosEstado: { id: selectEstadosId },
      provincia: this.searchForm.get('provincia_fisica')?.value,
      nima: this.searchForm.get('nima')?.value,
      autorizacionPeligrosos: this.searchForm.get('auto_peligrosidad')?.value,
      acuerdoEnvalora:
        this.searchForm.get('acuerdoEnv')?.value === 'Si'
          ? true
          : this.searchForm.get('acuerdoEnv')?.value === 'No'
          ? false
          : undefined,
      convenioEnvalora:
        this.searchForm.get('convAcondicionador')?.value === 'Si'
          ? true
          : this.searchForm.get('convAcondicionador')?.value === 'No'
          ? false
          : undefined,
    };
    if(this.searchForm.get('gestores')?.value){
      backendFilter.gestorResiduos = this.searchForm.get('gestores')?.value
    }
    if(this.searchForm.get('acondicionadores')?.value){
      backendFilter.acondicionadorEnvase = this.searchForm.get('acondicionadores')?.value
    }
    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    const orden = this.searchForm.get('orden')?.value;
    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    const sort = ['id,desc'];
    return { backendFilter, page, size: this.pageSize, sort, orden, tipoOrden };
  }

  searchData(initPage:boolean = false) {
    if(initPage){
      this.pageNumber = 0;
    }
    if (this.searchForm.invalid) {
      this.searchForm.markAllAsTouched();
      return;
    }
    const { backendFilter, page, size, sort, orden, tipoOrden } = this.getBackendFilter();
    this.spinnerSrv.loadingShow();
    this.gestoresResiduosControllerService
      .findAll8(backendFilter,
        {
        page: page,
        size: size,
        sort: sort,
      },orden,
        tipoOrden,)
      .subscribe({
        next: (data: PageDTOGestoresResiduosDTO) => {
          if (data) {
            this.spinnerSrv.loadingHide();
            this.flagSearch = data.datos?.length != 0 ? true : false;
            this.gridArray = this.canAccessAll(data.datos);
            this.recordsTotal = data.paginacion?.totalElements ?? 0;
            this.totalSearch = this.gridArray.length;
          }
        },
        error: (error: any) => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.searchData();
  }

  action(element: any) {
    if (element.nameButton == 'view') {
      this.openDetailShow(element.id);
    } else if (element.nameButton == 'delete') {
      this.confirmacionEliminar(element);
    } else if (element.nameButton == 'baja_gestor') {
      this.abrirDialogoMotivoBaja(element);
    }
  }

  private abrirDialogoMotivoBaja(element: any): void {
    const dialogRef = this.dialog.open(WasteManagersBajaMotivoDialogComponent, {
      width: '600px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: {
        gestores: [element],
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.darBajaGestor(element);
      }
    });
  }

  confirmacionEliminar(element?: any): void {
    Swal.fire({
      text: `¿Desea eliminar el gestor?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.eliminarGestor(element);
      }
    });
  }

  darBajaGestor(element?: any) {
    // this.spinnerSrv.loadingShow();
    this.gestoresResiduosControllerService
      .bajaGestorResiduo(element.id)
      .subscribe({
        next: (value: any) => {
          // this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            `Al gestor de residuos se le ha dado de baja correctamente.`,
            'success'
          );
          this.searchData();
        },
        error: (err: { message: any }) => {
          // this.spinnerSrv.loadingHide();
        },
      });
  }

  eliminarGestor(element?: any) {
    if (element?.id) {
      this.spinnerSrv.loadingShow();
      this.gestoresResiduosControllerService.deleteById4(element.id).subscribe({
        next: (value: any) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            `El gestor se ha eliminado correctamente`,
            'success'
          );
          this.gridArray = this.gridArray.filter(
            (objeto) => objeto.id !== element.id
          );
          this.flagSearch = this.gridArray.length != 0 ? true : false;
        },
        error: (err: { message: any }) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al eliminar el gestor',
            'error'
          );
        },
      });
    }
  }

  getCnaDescription(cnae: any) {
    return cnae.clase + ' - ' + cnae.descripcion;
  }

  getCnaeObjectQuery(searchterm: string) {
    return {
      descripcion: `or(ci(${searchterm}))`,
      clase: `or(ci(${searchterm}))`,
    };
  }

  public rightHolder(controlName: string) {
    let cl2 = '';
    if (
      (this.searchForm.controls[controlName]?.touched ||
        this.searchForm.controls[controlName]?.dirty) &&
      this.searchForm.controls[controlName]?.errors
    ) {
      cl2 = 'error-focus-input';
    } else {
      cl2 = 'success-focus-input';
    }
    return `${cl2}`;
  }

  showClearButton(formName: string): boolean {
    return this.searchForm.get(formName)?.value !== null;
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.searchForm.get(formName)?.setValue(null);
  }

  getComboEstados() {
    this.gestoresResiduosEstadosControllerService.findAll9().subscribe({
      next: (data: any) => {
        this.estadoArray = data!;
      },
      error: () => {},
    });
  }

  openDetailShow(id: number): void {
    // Guardar formulario en sessionStorage antes de navegar
    const formValue = this.searchForm.getRawValue();
    sessionStorage.setItem('wasteManagersSearchForm', JSON.stringify(formValue));
    console.log('[WasteManagersSearch openDetailShow] Formulario guardado en sessionStorage:', formValue);
    this.holdersService.setTempHoldersSearch(true);
    this.router.navigate(['/holders/waste-managers-detail', id], {
      state: { searchForm: formValue }
    });
  }

  canAccessAll(list: any) {
    const resultView = this.authService.can('poseedores-gestor', 'view');
    const resultDelete = this.authService.can('poseedores-gestor', 'delete');
    const resultUpdateUnregister = this.authService.can(
      'poseedores-gestor',
      'update-unregister'
    );
    const listPermission = list.map((objeto: any) => {
      const estadoDelete =
        objeto.gestoresResiduosEstado &&
        [1].includes(objeto.gestoresResiduosEstado.id);
      const estadoUpdateUnregister =
        objeto.gestoresResiduosEstado && objeto.gestoresResiduosEstado.id === 2;

      return {
        ...objeto,
        canAccessView: resultView,
        canAccessDelete: resultDelete && estadoDelete,
        canAccessDownManager: resultUpdateUnregister && estadoUpdateUnregister,
      };
    });

    return listPermission;
  }

  getComboProvincia() {
    this.provinciaControllerService
      .listarComunidades1({}, { page: 0, size: 500, sort: [] })
      .subscribe({
        next: (data: any) => {
          this.provinciaArray = data.datos!;
        },
        error: () => {},
      });
  }

  onlyNumberKey(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Control'];

    if (event.ctrlKey && (event.key === 'c' || event.key === 'v')) return;

    // Permitir números y teclas adicionales definidas
    if (!/^[0-9;]$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }
  canAccessChangeStatus(): boolean {
    return this.canViewResource('AD-ENV-GEST');
  }

  comprobarCambioEstado() {
    const list = this.gridArray
      .filter((x: any) => x.checked === true)
      .map((x: any) => x.id);

    if (list.length == 0) {
      this.snackBarSrv.showSnackBar(
        'Debe seleccionar al menos un gestor/acondicionador para realizar el cambio de estado.',
        'error'
      );
      return;
    }

    const selectedGestores = this.gridArray.filter((p: any) =>
      list.includes(p.id)
    );
    const estadoActual = (selectedGestores[0] as any).gestoresResiduosEstado?.id;
    if (
      !selectedGestores.every(
        (item: any) => item.gestoresResiduosEstado?.id == estadoActual
      )
    ) {
      this.snackBarSrv.showSnackBar(
        'Todos los gestores/acondicionadores seleccionados deben tener el mismo estado.',
        'error'
      );
      return;
    }

    const dialogRef = this.dialog.open(WasteManagersStatusChangeDialogComponent, {
      width: '950px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: {
        gestores: selectedGestores,
        estadoActual: estadoActual,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.searchData(true);
      }
    });
  }
  getComboOrden() {
    this.diccionarioControllerService.listarElementos(['ORDEN_POSEEDORES_GESTORES_ACONDICIONADORES_BUSQUEDA'])
      .subscribe({
        next: (data: any) => {
          this.orden = data['ORDEN_POSEEDORES_GESTORES_ACONDICIONADORES_BUSQUEDA'];
        },
        error: () => {},
      });
    }
}
